import React from 'react';
import PropTypes from 'prop-types';
import './SidebarSection.css';

/**
 * A reusable sidebar section component that groups related sidebar content
 * Using BEM naming convention for CSS classes
 */
const SidebarSection = ({ 
  title,
  className = '',
  children
}) => {
  return (
    <div className={`sidebar__section ${className}`}>
      {title && <h4 className="sidebar__section-title">{title}</h4>}
      {children}
    </div>
  );
};

SidebarSection.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default SidebarSection;